export default "__VITE_ASSET__C1Ng1vo2__"